<template>
	<v-dialog v-model="isVisible" :max-width="width" content-class="youtube-dialog-content">
		<div class="youtube-dialog" v-if='isVisible'>
			<div class="youtube-dialog--close" @click="close()">
				<close-icon></close-icon>
			</div>
			<div class="youtube-dialog--container">
				<iframe
					width="560"
					height="315"
					:src="getYoutubeEmbedSrc(videoSrc)"
					title="YouTube video player"
					frameborder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					allowfullscreen
				></iframe>
			</div>
		</div>
	</v-dialog>
</template>
<script>
import CloseIcon from '../icons/close-icon';

export default {
	name: 'youtube-dialog',
	components: { CloseIcon },
	props: {
		videoSrc: {
			required: true,
		},
		width: {
			default: '800',
		},
	},
	data() {
		return {
			isVisible: false,
		};
	},
	methods: {
		getYoutubeId(url) {
			const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
			const match = url.match(regExp);
			return match && match[2].length === 11 ? match[2] : null;
		},
		getYoutubeEmbedSrc(url) {
			return `//www.youtube.com/embed/${this.getYoutubeId(url)}`;
		},
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.youtube-dialog {
	position: relative;

	&--close {
		position: absolute;
		top: -15px;
		right: -15px;
		background: white;
		border-radius: 50%;
		cursor: pointer;
		width: 30px;
		height: 30px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		z-index: 10;
	}

	&--container {
		height: 0;
		overflow: hidden;
		padding-bottom: 56.25%;
		padding-top: 30px;
		position: relative;

		iframe,
		object,
		embed {
			height: 100%;
			left: 0;
			position: absolute;
			top: 0;
			width: 100%;
		}
	}
}
</style>

<style lang="scss">
.youtube-dialog-content {
	overflow: initial;
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/business/youtube-dialog.vue